import API from "./API";

class Category {
  static async all() {
    return API.get("/public/locations/categories", { cache: true });
  }
}

export default Category;
